import { Col, Image, Row } from 'antd';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Logo from '../../assets/logo-w.png';
import { setAppLoader } from '../../redux/common/CommonActions';
import WithImageWraper from '../components/Common/WithImageWraper';
import PrimaryLabel from '../components/Labels/PrimaryLabel';

const ActionNeededLayouts = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setAppLoader(false));
  }, []);

  return (
    <WithImageWraper>
      <div className="action-needed-layout-main">
        <div className="background-dark header">
          <Row justify="space-between py-15 px-30">
            <Col>
              <Image src={Logo} preview={false} height={30} alt="Logo" />
            </Col>
            <Col />
          </Row>
        </div>
        <div className="flex-1 overflow-hidden content-container">
          <Outlet />
        </div>
        <div className="background-dark text-center footer py-15 px-30">
          <PrimaryLabel className="text-white">© Copyright @nvisionglobal 2014</PrimaryLabel>
        </div>
      </div>
    </WithImageWraper>
  );
};

export default ActionNeededLayouts;
